import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  getCountryLabelFromCountries,
  localizeCountryInCompositeLabel,
} from 'i18n/countryLabel';
import { localizeReturnMappingLabel } from 'i18n/returnTypeLabel';
import { getCommonCountries } from 'store/common/selectors';

export function useCountryLabel() {
  const { i18n, t } = useTranslation();
  const countries = useSelector(getCommonCountries);

  const localizeCountry = useCallback(
    (isoOrName?: string, fallbackName?: string) =>
      getCountryLabelFromCountries(
        isoOrName,
        countries,
        i18n.language,
        fallbackName
      ),
    [countries, i18n.language]
  );

  const localizeCountryLabel = useCallback(
    (label?: string) =>
      localizeCountryInCompositeLabel(label, countries, i18n.language),
    [countries, i18n.language]
  );

  const localizeReturnLabel = useCallback(
    (label?: string) =>
      localizeReturnMappingLabel(label, countries, i18n.language, t),
    [countries, i18n.language, t]
  );

  return {
    countries,
    language: i18n.language,
    localizeCountry,
    localizeCountryLabel,
    localizeReturnLabel,
  };
}
